import { useMemo } from 'react';
import { useWindowWidth } from '../util/useWindowWidth';

export function useClinicalSimulationGridTemplateColumns({
    hideTabs,
    showCondition_C,
    showCondition_I,
    showCondition_S,
    showCondition_P,
    showCondition_PICS,
    showCondition_IC,
    showCondition_CS,
    showCondition_ISC,
    showCondition_PIC,
    showCondition_PSC,
    showCondition_PCS,
    showCondition_PIS
}) {
    const { currentWindowWidth } = useWindowWidth();

    const commentSectionWidth = useMemo(() => {
        if (hideTabs) {
            return '2fr';
        }
        if (currentWindowWidth > 1536) {
            return '450px';
        }
        if (currentWindowWidth > 1200) {
            return '400px';
        }
        return '0px';
    }, [hideTabs, currentWindowWidth]);

    const gridTemplateArray = useMemo(() => {
        if (currentWindowWidth > 1200) {
            if (showCondition_C) {
                return [commentSectionWidth]; // comment
            }
            if (showCondition_I || showCondition_S || showCondition_P) {
                return [`1fr`]; // for single section
            }
            if (showCondition_PICS) {
                return [`1fr`, `2fr`, `2fr`, commentSectionWidth]; // photos-idesign-smile-comment
            }
            if (showCondition_PSC) {
                return [`1fr`, `2fr`, commentSectionWidth]; // photos-smile-comment
            }
            if (showCondition_ISC) {
                return [`3fr`, `2fr`, commentSectionWidth]; // idesign-smile-comment
            }
            if (showCondition_PCS) {
                return [`1fr`, commentSectionWidth, `1fr`]; // photo-comment-smile
            }
            if (showCondition_IC) {
                return [`2fr`, commentSectionWidth]; // idesign-comment
            }
            if (showCondition_CS) {
                return [`2fr`, commentSectionWidth]; // smile-comment
            }
            if (showCondition_PIC) {
                return [`1fr`, `2fr`, commentSectionWidth]; // photos-idesign-comment
            }
            if (showCondition_PIS) {
                return [`1fr`, `2fr`, commentSectionWidth]; // photos-idesign-smile
            }
            return [`1fr`, `1fr`];
        }
        if (currentWindowWidth > 700) {
            return [`1fr`, `1fr`];
        }
        return [`1fr`];
    }, [
        currentWindowWidth,
        commentSectionWidth,
        showCondition_C,
        showCondition_I,
        showCondition_P,
        showCondition_S,
        showCondition_PICS,
        showCondition_PSC,
        showCondition_ISC,
        showCondition_PCS,
        showCondition_IC,
        showCondition_CS,
        showCondition_PIC,
        showCondition_PIS,
    ]);

    const gridTemplateColumns = useMemo(() => gridTemplateArray.join(' '), [gridTemplateArray]);

    return { gridTemplateColumns, gridTemplateArray, commentSectionWidth };
}
